import React from "react";

import DigitalDentalSolutionsLogo from "../layouts/img/vendors/digital_dental_solutions_logo.png";
import ArrowNothMarketingLogo from "../layouts/img/vendors/arrow-north-logo.png";
import buzzyBoothLogo from "../layouts/img/vendors/buzzyBoothLogo.png";
import MitSolutionsLogo from "../layouts/img/vendors/mitsolutions.png";
import BurstLogo from "../layouts/img/vendors/burst.png";
import SeoDentistLogo from "../layouts/img/vendors/seo-dentist.png";
import TierOneFinancialLogo from "../layouts/img/vendors/tier-one-financial.png";
import ConnectTheDocLogo from "../layouts/img/vendors/connect-the-doc.png";
import SerpCoLogo from "../layouts/img/vendors/serp.png";

// TODO make this come from the api and be manageable by the admin panel
const VENDORS = [
  {
    image: {
      src: DigitalDentalSolutionsLogo,
      alt: "Digital Dental Solutions"
    },
    title: "Digital Dental Solutions",
    phone: "(916) 458-6210",
    email: "info@ddstech.com",
    website: {
      url: "http://www.ddstech.com/",
      label: "www.ddstech.com"
    }
  },
  {
    image: {
      src: ArrowNothMarketingLogo,
      alt: "Arrow North Marketing & Consulting"
    },
    title: "Arrow North Marketing & Consulting",
    phone: "(916) 303-3348",
    email: "arrownorthmarketing@gmail.com",
    website: {
      url: "http://www.arrownorthmarketing.com/",
      label: "www.arrownorthmarketing.com"
    }
  },
  {
    image: {
      src: buzzyBoothLogo,
      alt: "BuzzyBooth"
    },
    title: "BuzzyBooth",
    phone: "(424) 330-2237",
    email: "destiny@buzzybooth.com",
    website: {
      url: "http://buzzybooth.com/#/dental-home",
      label: "buzzybooth.com"
    }
  },
  {
    image: {
      src: BurstLogo,
      alt: "Burst Oral Care"
    },
    title: "Burst Oral Care",
    phone: "(833) BURSTUS",
    email: "hello@burstoralcare.com",
    website: {
      url: "http://burstambassadors.com/",
      label: "burstambassadors.com"
    }
  },
  {
    image: {
      src: ConnectTheDocLogo,
      alt: "Connect the Doc"
    },
    title: "Connect the Doc",
    phone: "(415) 287-4999",
    email: "nadeem@connectthedoc.com",
    website: {
      url: "http://getconnectthedoc.com/",
      label: "getconnectthedoc.com"
    }
  },
  {
    image: {
      src: SeoDentistLogo,
      alt: "The SEO Dentist"
    },
    title: "The SEO Dentist",
    phone: "(360) 632-9707",
    email: "sage@theseodentist.com",
    website: {
      url: "https://theseodentist.com/",
      label: "theseodentist.com"
    }
  },
  {
    image: {
      src: TierOneFinancialLogo,
      alt: "Tier One Financial"
    },
    title: "Tier One Financial",
    phone: "(916) 878-3333",
    email: "dvanorder@financialguide.com",
    website: {
      url: "http://www.tieronefinancial.com/",
      label: "www.tieronefinancial.com"
    }
  },
  {
    image: {
      src: MitSolutionsLogo,
      alt: "Mission IT Solutions"
    },
    title: "Mission IT Solutions",
    phone: "(209) 257-4620",
    email: "admin@missionit.tech",
    website: {
      url: "http://missionitsolutions.com/",
      label: "missionitsolutions.com"
    }
  },
  {
    image: {
      src: SerpCoLogo,
      alt: "SERP Dental"
    },
    title: "SERP Dental",
    phone: null,
    email: "info@serp.co",
    website: {
      url: "http://serp.co/dental",
      label: "serp.co/dental"
    }
  }
];

const Vendors = () => (
  <div id="main" className="site-main">
    <div className="hero hero-subpage">
      <div className="hero-content">
        <div className="container">
          <div className="row text-center">
            <h1 className="h-70 weight-bold">Swiss Monkey</h1>
            <h2 className="h-70 weight-bold">Vendors &amp; Partnerships</h2>
          </div>

          <main class="main-area">
            {VENDORS.map(vendor => (
              <aside class="partner">
                <img src={vendor.image.src} alt={vendor.image.alt} />
                <div className="partner-details">
                  <h3 className="vendor-title p-blue weight-bold">
                    {vendor.title}
                  </h3>
                  {vendor.phone && (
                    <div className="vendor-phone">{vendor.phone}</div>
                  )}
                  <div className="vendor-email">
                    <a href={`mailto:${vendor.email}`}>{vendor.email}</a>
                  </div>
                  <div className="vendor-web">
                    <a
                      href={vendor.website.url}
                      title={vendor.title}
                      target="_blank"
                    >
                      {vendor.website.label}
                    </a>
                  </div>
                </div>
              </aside>
            ))}
          </main>
        </div>
      </div>
    </div>
  </div>
);

export default Vendors;



// WEBPACK FOOTER //
// ./src/pages/vendors.js